import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import { Modal, ModalContent, ModalBackdrop, ModalHeader, ModalCloseButton } from "@/components/ui/modal";
import { HStack } from "@/components/ui/hstack";
import { Button } from "@/components/ui/button";
import { View } from '@/components/ui/view';
import { IconMC } from "@/components/media/IconsV2";
import { ScrollView } from "react-native-gesture-handler";
import React from 'react'
import i18n from "i18n-js";

export default function ModalBase(props) {
    return (
        <Modal isOpen={props.showModal} onClose={() => {
            // ? `Modal.onClose` will trigger on pressing [Escape] even if the model is already closed.
            if (props.showModal) props.setShowModal(false)
        }}>
            <ModalBackdrop />
            <ModalContent className={`max-w-[700px] max-h-[80%] ${props.className || ''}`}>
                <ModalHeader className="mb-2">
                    <Text bold className="text-secondary-900 text-2xl">{i18n.t(props.title)}</Text>
                    <ModalCloseButton className='bg-secondary-100'>
                        <View className='bg-primary-50 border-2 border-primary-900 rounded-[4px] p-1 w-fit self-end'>
                            <IconMC className='text-primary-900' size={24} name='close' />
                        </View>
                    </ModalCloseButton>
                </ModalHeader>
                {props.info && <Text className="text-xl text-secondary-900 mb-3">{i18n.t(props.info)}</Text>}
                <ScrollView>
                    <VStack space='md'>
                        {props.children}
                    </VStack>
                </ScrollView>
                <HStack space='lg' className="mt-5 justify-end">
                    {props.buttonL && <Button onPress={() => { props.onButton(false) }} className="self-end bg-primary-900 py-3 px-5">
                        <Text className="text-lg text-secondary-50">{i18n.t(props.buttonL)}</Text>
                    </Button>}
                    {props.buttonR && <Button disabled={props.disabled} onPress={() => { props.onButton(true) }} className={` ${props.disabled ? "bg-secondary-700" : "bg-primary-900"} self-end py-3 px-5 `}>
                        <Text className="text-lg text-secondary-50">{i18n.t(props.buttonR)}</Text>
                    </Button>}
                </HStack>
            </ModalContent>
        </Modal>
    );
}
